import React from 'react';
import ReactDOM from 'react-dom';
// Estilos de PrimeReact empaquetados desde node_modules (versión fijada por
// package-lock). Antes se cargaban de unpkg sin versión y la release de
// PrimeReact 11 los rompió en producción sin mediar despliegue.
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './index.scss';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
